import { useState } from "react";

import clsx from "clsx";

import {
  DebouncedSearchInput,
  PrimaryIconButton,
  TertiaryButton,
} from "@components/v2";

import { FilterModal } from "./filter-modal";
import { useOrdersQueryParams } from "./hooks/use-orders-filters";
import { MaximizeTableDrawer } from "./maximize-table-drawer";
import { MetricFilters } from "./metric-filters";
import { type QuickFilter } from "./types";

type Props = {
  className?: string;
  showMaximize?: boolean;
  selectedQuickFilter: QuickFilter;
};

export const OrdersTableSettings = ({
  className,
  showMaximize,
  selectedQuickFilter,
}: Props) => {
  const [maximizeTableModalOpen, setMaximizeTableModalOpen] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [state, setQuery] = useOrdersQueryParams();

  return (
    <div className={clsx("flex flex-row gap-3 justify-between", className)}>
      <div className="flex flex-row gap-2">
        {showMaximize && (
          <PrimaryIconButton
            size="sm"
            onClick={() => setMaximizeTableModalOpen(true)}
          >
            <div className="h-[24px] w-[24px] bg-v2-overlay-shadow-200 rounded-[24px] flex items-center justify-center">
              <i className="fa-regular fa-arrow-left-to-line" />
            </div>
          </PrimaryIconButton>
        )}
        <div className="w-[260px]">
          <DebouncedSearchInput
            value={state.orderId || ""}
            onChange={(value) => {
              setQuery({ ...state, orderId: value });
            }}
          />
        </div>
      </div>
      <div>
        <MetricFilters onModalOpen={() => setFilterModalOpen(true)} />
      </div>
      <MaximizeTableDrawer
        isOpen={maximizeTableModalOpen}
        onClose={() => setMaximizeTableModalOpen(false)}
        selectedQuickFilter={selectedQuickFilter}
      />
      <FilterModal
        isOpen={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
      />
    </div>
  );
};
